import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=70d30974&scoped=true&"
var script = {}
import style0 from "./Auth.vue?vue&type=style&index=0&id=70d30974&lang=scss&scoped=true&"
import style1 from "./Auth.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d30974",
  null
  
)

export default component.exports